import { Components } from "appworks/components/components";
import { canvasManager } from "appworks/graphics/canvas/canvas-manager";
import { gamevyForceLoader } from "gamevy/debug/menu/gamevy-force-loader";
import { AbstractMatrixComponent } from "slotworks/components/matrix/abstract-matrix-component";
import { SpinReelTransition } from "slotworks/components/matrix/reel/transition-behaviours/spin/spin-reel-transition";
import { ReelsetControlDebugger } from "slotworks/debug/reelset-control-debugger";
import { slotDefinition } from "slotworks/model/slot-definition";

export class GamevyReelsetControlDebugger extends ReelsetControlDebugger {
    public start() {
        this.draw();
    }

    public toggle() {
        const reelsets = gamevyForceLoader.getSymbolIdReelsets() || slotDefinition.reelsets;
        const firstReelsetId = Array.from(reelsets.keys())[0];

        if (!this.containerEl) {
            this.start();
            this.setReelset(firstReelsetId);
        } else {
            if (this.containerEl.parentElement) {
                canvasManager.rootNode.removeChild(this.containerEl);
            } else {
                canvasManager.rootNode.appendChild(this.containerEl);
                this.setReelset(firstReelsetId);
            }
        }
    }

    protected draw() {
        this.containerEl = document.createElement("div");
        this.containerEl.classList.add("reelset-control");

        this.selectReelsetEl = document.createElement("select");
        this.selectReelsetEl.classList.add("reelset-control__reelset-selector");
        this.containerEl.appendChild(this.selectReelsetEl);

        const reelsets = gamevyForceLoader.getSymbolIdReelsets() || slotDefinition.reelsets;

        for (const reelsetId of Array.from(reelsets.keys())) {
            const option = document.createElement("option");
            option.value = reelsetId;
            option.innerText = reelsetId;
            this.selectReelsetEl.appendChild(option);
        }

        this.selectReelsetEl.addEventListener("change", () => this.setReelset(this.selectReelsetEl.value));

        const upRowEl = document.createElement("div");
        upRowEl.classList.add("reelset-control__row");
        this.containerEl.appendChild(upRowEl);

        const downRowEl = document.createElement("div");
        downRowEl.classList.add("reelset-control__row");
        this.containerEl.appendChild(downRowEl);

        for (let i = 0; i < slotDefinition.matrixGrid.length; i++) {
            const btn = document.createElement("button");
            btn.innerHTML = "▲";
            btn.addEventListener("pointerdown", () => this.reelUp(i));
            upRowEl.appendChild(btn);
        }

        for (let i = 0; i < slotDefinition.matrixGrid.length; i++) {
            const btn = document.createElement("button");
            btn.innerHTML = "▼";
            btn.addEventListener("pointerdown", () => this.reelDown(i));
            downRowEl.appendChild(btn);
        }

        this.reelstopsEl = document.createElement("input");
        this.reelstopsEl.classList.add("reelset-control__reelstops");
        this.containerEl.appendChild(this.reelstopsEl);

        canvasManager.rootNode.appendChild(this.containerEl);

        if (!this.reelsLandedBinding) {
            this.reelsLandedBinding = Components.get(AbstractMatrixComponent).getTransition().onReelLand.add((reelIndex) => {
                if (reelIndex === slotDefinition.matrixGrid.length - 1) {
                    setTimeout(() => this.updateReelstops(), 100);
                }
            });
        }

        this.updateReelstops();
    }

    protected reelDown(reelIndex: number) {
        const transition = Components.get(AbstractMatrixComponent).getTransition() as SpinReelTransition;
        const reelSpinner = transition.getSpinners()[reelIndex];
        reelSpinner.previousSymbol();

        this.updateReelstops();
    }

    protected reelUp(reelIndex: number) {
        const transition = Components.get(AbstractMatrixComponent).getTransition() as SpinReelTransition;
        const reelSpinner = transition.getSpinners()[reelIndex];
        reelSpinner.nextSymbol();

        this.updateReelstops();
    }

    protected setReelset(reelsetId: string) {
        const reelsets = gamevyForceLoader.getSymbolIdReelsets() || slotDefinition.reelsets;
        const reelset = reelsets.get(reelsetId);
        Components.get(AbstractMatrixComponent).setCustomReelset(reelset);
        const transition = Components.get(AbstractMatrixComponent).getTransition() as SpinReelTransition;
        transition.getSpinners().forEach((spinner) => spinner.updateSymbolPositions());

        this.updateReelstops();
    }

    protected updateReelstops() {
        const transition = Components.get(AbstractMatrixComponent).getTransition() as SpinReelTransition;

        const reelstops: number[] = [];
        for (const reel of transition.getSpinners()) {
            const reelstop = reel.getCurrentPosition();
            reelstops.push(reelstop);
        }

        this.reelstopsEl.value = reelstops.join(", ");
    }
}
